export default "__VITE_ASSET__CjUn4fun__"